/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "surveyprocessing",
	init: init,
	triggers: triggers,
	listeners: listeners,

	pending: false,
	surveys: [],

	_coreforms: {},
	_coreforms_ids: [],

	handle_responded: handle_responded,
	check_schema: check_schema,
	add_submission: add_submission,
	remove_submission: remove_submission,
	refresh_surveys: refresh_surveys,

});

function listeners() {
	return {
		"mqtt:$/survey/send": handle_survey,
		"mqtt:$/survey/updated": handle_responded,
		"coreforms:updated": handle_coreforms,
		"connectivity:online": refresh_surveys
	};
}

function triggers() {
	return ({
		respond: handle_send_response, // receives the submission (_id) and response (data)
	});
}

function init() {
	this.refresh_surveys();

	this.push({
		pending: false
	});
}

function handle_send_response(data) {
	// response is always to the first element in the array of surveys
	var submission = this.data.surveys[0]._id;
	if (!submission) return;
	var response = data;
	// put response in form for handle_responded()
	var response_local = {
		submission: submission
	};
	this.api.forms.survey.update(submission, response)
		.catch(handle_submission_error.bind(this, response_local));
}

/**
 * Handles clearing survey even if error on responding
 */
function handle_submission_error(response, error) {
	console.error(error);
	this.handle_responded(response);
}

/**
 * Surveys are added as 'submissions'. An array keeps track of pending
 * submissions.
 */
function handle_survey(data) {
	var submission = data.submission;
	var schema = data.schema["_id"];
	var manager = data.manager;
	if (!this.check_schema(schema)) return;

	this.add_submission(submission, schema, manager);
}

/**
 * If the survey is properly responded to, the server sends a message with the
 * satisfied submission _id, which is removed from the 'surveys' array.  If no
 * more surveys remain, pending is set to false.
 */
function handle_responded(data) {
	var submission = data.submission;
	this.remove_submission(submission);
	if (!this.data.surveys.length) {
		this.extend({
			pending: false
		});
	}
}

/**
 * This keeps track of the list of existing 'core' forms.
 * It reacts to updates from the latter model and keeps
 * the list in a private variable.
 */
function handle_coreforms(data) {
	this._coreforms = data;
	var keys = Object.keys(data);
	this._coreforms_ids = keys.map(function(core) {
		return data[core]._id;
	});
}

/**
 * These functions add, remove, and recover submissions.  In both cases the submissions
 * are stored locally for recovery purposes.
 */
function add_submission(submission, schema, manager) {
	var old = this.data.surveys;
	var updated = old.concat([{
		_id: submission,
		schema: schema,
		creator: manager
	}]);

	this.extend({
		surveys: updated,
		pending: true
	});
}

function remove_submission(submission) {
	var old = this.data.surveys;
	var remaining_submissions = true;
	var filtered = old.filter(function (item) {
		return item._id !== submission;
	});
	if (filtered.length === 0) remaining_submissions = false;

	this.extend({
		surveys: filtered,
		pending: remaining_submissions
	});
}

function refresh_surveys() {
	this.api.forms.survey.pending()
		.then(recalculate.bind(this));
}

function recalculate (result) {
	var pending = false;
	var surveys = [];
	if (result.length > 0) {
		pending = true;
		surveys = result;
	}
	this.extend({
		pending: pending,
		surveys: surveys
	});
}

/**
* Verify that the desired survey form exists
*/
function check_schema(schema) {
	var existing = this._coreforms_ids;
	if (existing.indexOf(schema) !== -1) return true;
	return false;
}
